export default __webpack_public_path__ + "static/media/Rectangle 7.bd0680af.png";